
import { computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';

// enums
import { TodosMutationTypes } from '@/models/todos';

export default {
  name: 'Todos',
  setup() {
    const store = useStore();

    const todos = computed(() => store.getters.todos);
    const allTodos = computed(() => store.getters.allTodos);
    const doneTodos = computed(() => store.getters.doneTodos);

    const handleMarkCompleted = (todoId: string) => {
      store.commit(TodosMutationTypes.MARK_COMPLETED, todoId);
    };

    const handleDeleteTodo = (todoId: string) => {
      store.commit(TodosMutationTypes.DELETE_TODO, todoId);
    };

    onMounted(() => {
      store.commit(TodosMutationTypes.SET_TODOS);
    });

    watch(doneTodos, () => {
      if (doneTodos.value.length === 0) {
        store.commit(TodosMutationTypes.SET_STATUS, 'all');
      }
    });

    return {
      todos,
      allTodos,
      handleMarkCompleted,
      handleDeleteTodo,
    };
  },
};
